import React, { Component } from 'react';
import '../styles/ShowMore.css';
import LoadIndicator from './LoadIndicator'
import arrowBlackIcon from '../icons/arrow-down-black.svg'
import styled from 'styled-components'

const IconArrow = styled.img`
    display: block;
    padding-top: 20px;
    margin: auto;
    height: 35px;
    width: 35px;
    cursor: pointer;
`;

class ShowMore extends Component {
    constructor(){
        super();
        this.state = {
            showText : "VER MÁS"
        }
    }
    toggleText(e, textId) {
        let arrow = e.target
        let text = document.getElementById(textId)
        if(arrow.classList.contains("toggle")){
            arrow.style.transform = "rotate(0deg)"
            arrow.classList.remove("toggle")
            arrow.style.paddingTop = "20px"
            arrow.style.paddingBottom = "0px"
            text.style.display = "none"
            this.setState({
                showText: "VER MÁS"
            })
        } else {
            text.style.display = "block"
            arrow.style.transform = "rotate(180deg)"
            arrow.classList.add("toggle")
            arrow.style.paddingTop = "0px"
            arrow.style.paddingBottom = "20px"
            this.setState({
                showText: "VER MENOS"
            })
        }
        if(this.props.onClick){
            this.props.onClick(e)
        }
    }
    render(){
        let loadIndicator = this.props.loadEffect ? <LoadIndicator className="load-empresa"/> : ""
        const Component = this.props.component || IconArrow;
        return (
            <div className="show-more-component">
                {loadIndicator}
                <Component src={arrowBlackIcon} id="arrow" onClick={((e) => this.toggleText(e, this.props.textId))}/>
                <p class="text-show-more">{this.state.showText}</p>
            </div>
        );
    }
}

ShowMore.defaultProps = {
    loadEffect : true
}

export default ShowMore;



// WEBPACK FOOTER //
// ./src/components/ShowMore.js